import React from 'react';
import styled from 'styled-components';

import MicrosoftIconSrc from './microsoft-icon.svg';
import Typography from 'kingpin/atoms/Typography';
import Row from '../../../components/Common/Row';

const IconImg = styled.img`
  margin-right: 8px;
`;

const Button = styled.div`
  padding: 0px 16px;
  cursor: pointer;
  text-align: center;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background-color: var(--color-bg-primary);
  border: 1px solid var(--color-border-primary);
  border-radius: 10px;

  height: 41px;

  transition: background-color 150ms ease;

  &:hover {
    background-color: var(--color-bg-input);
  }
`;

const Icon = () => <IconImg src={MicrosoftIconSrc} />;

const MicrosoftLoginButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <Button onClick={onClick}>
      <Row centerAlign>
        <Icon />
        <Typography.Body type="Button Text">
          Sign in with Microsoft
        </Typography.Body>
      </Row>
    </Button>
  );
};

export default MicrosoftLoginButton;
